import { render, staticRenderFns } from "./schooldepartments.vue?vue&type=template&id=dbd355e4&"
import script from "./schooldepartments.vue?vue&type=script&lang=js&"
export * from "./schooldepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports